import styled from 'styled-components'
import { FlexContainer } from '../../common/Wrappers/Containers'

export const MobileMenuContent = styled(FlexContainer)`
  padding: 0 16px 40px;
  flex-grow: 1;
  align-items: stretch;
  flex-direction: column;
`
